// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchRoles({ commit }) {
    return get(`/user/roles`)
      .then(({ data }) => {
        commit('addRoles', data)
      })
  },
  async fetchRolesPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', name = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(name && { name }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/user/roles?${queryParams}`);
    commit("addRolesPage", data)
    return data;
  },
  createRoles({ commit }, roles) {
    return post("/user/roles/add", roles).then(({ data }) => {
      //commit("addRoles", data);
    });
  },
  updateRoles({ commit }, roles) {
    return put(`/user/roles/edit/${roles.id}`, roles).then(({ data }) => {
      //commit("replaceRoles", data);
    });
  },
  createOrUpdateRoles({ dispatch }, roles) {
    if (roles.id !== undefined) {
      return dispatch('updateRoles', roles)
    } else {
      return dispatch('createRoles', roles) 
    }
  },
  selectRoles({ commit }, roles) {
    commit('setRoles', roles)
  },
  deleteRoles({ commit }, roles) {
    return remove(`/user/roles/${roles.id}`)
      .then(({ data }) => { })
  },
}
